import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

const useParams = (): Record<string, string | string[]> => {
  const router = useRouter();
  const params = router.query;
  const [referrer, setReferrer] = useState('');

  // get referer params from document or cookie and reform to query param structure
  const getReferrer = (): void => {
    let referrerValue;
    if (typeof window === 'object') {
      referrerValue = document?.referrer;
    }
    setReferrer(referrerValue);
  };

  useEffect(() => {
    getReferrer();
  });

  return { ...params, referrer: referrer || params.referrer };
};

export default useParams;
